/**
 * Creates an AnswerButtonComponent
 * @param {EsgItem} answerEsgItem
 * @param {EsgItem} parentEsgItem
 * @returns {string}
 * @constructor
 */
function AnswerButtonComponent(answerEsgItem, parentEsgItem) {
  let childrenElements = '';
  if (answerEsgItem.answers) {
    childrenElements = answerEsgItem.answers?.join(',');
  }

  return `
        <button 
            data-children='${childrenElements}'
            data-parent='${parentEsgItem.item.id}'
            data-type='${parentEsgItem.item.type}'
            data-answer='${answerEsgItem.item.id}' 
            data-gate='${parentEsgItem.item.gate}'
            onclick='window.esgReaderInstance.esgButtonToggleButtonClick(this)' 
            class='disabled:opacity-75 grow md:grow-0 inline-flex items-center rounded-md border border-transparent bg-indigo-600 px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 esg-answer-button'
        >
            ${answerEsgItem.item.title}
        </button>
    `;
}

export default AnswerButtonComponent;
